export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          爆料投稿
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          有料你就来，我们珍惜每一条独家线索
        </p>
        <div className="mt-8 rounded-2xl border border-background-200/60 bg-background-100/50 p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 text-center">
            <div className="p-4 rounded-xl bg-background-50 border border-background-200/60">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-800">邮箱投稿</h3>
              <p className="mt-1 text-xs text-foreground-400">tips@51darkweb-news.example.com</p>
            </div>
            <div className="p-4 rounded-xl bg-background-50 border border-background-200/60">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500">
                <i className="ri-message-3-line text-xl"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-800">私信投稿</h3>
              <p className="mt-1 text-xs text-foreground-400">站内私信功能即将开放</p>
            </div>
            <div className="p-4 rounded-xl bg-background-50 border border-background-200/60">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500">
                <i className="ri-shake-hands-line text-xl"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-800">商务合作</h3>
              <p className="mt-1 text-xs text-foreground-400">bd@51darkweb-news.example.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}